<script>
export default {
    name: 'ServicePlanFeatureCalendahProvider',
};
</script>

<script setup>
import ServicePlanFeatureElementsArray
    from '@/components/payments/components/service-plan/components/features/components/elements/array.vue';
import { PROVIDER_LABEL } from '@/modules/calendah/domain/calendah-provider.ts';

defineProps({
    feature: {
        type: Object,
        required: true,
    },
});

const map = Object.fromEntries(PROVIDER_LABEL);
</script>

<template>
    <service-plan-feature-elements-array
        :feature="feature"
        :map="map"
        :unit="list => list.length > 1 ? 'providers' : 'provider'"
    />
</template>
